import { render, staticRenderFns } from "./studentCertificationInformation.vue?vue&type=template&id=04dae216&scoped=true"
import script from "./studentCertificationInformation.vue?vue&type=script&lang=js"
export * from "./studentCertificationInformation.vue?vue&type=script&lang=js"
import style0 from "./studentCertificationInformation.vue?vue&type=style&index=0&id=04dae216&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dae216",
  null
  
)

export default component.exports